import React, { useState } from 'react';
import Form from "react-bootstrap/Form";
import NguonKhachHangApi from "service/nguonKhachHangApi";
import { pushNotification } from "utils/notifications";

const CustomCheckbox = ({ id, name, checked, onChange, label, className = '' }) => (
    <div className={`form-group ${className}`} style={{ margin: 0 }}>
        <label htmlFor={id} className="custom-control custom-checkbox">
            <input type="checkbox" id={id} name={name} checked={checked} onChange={onChange} className="custom-control-input" />
            <span className="custom-control-indicator"></span>
            <span className="custom-control-description">{label}</span>
        </label>
    </div>
);

export const NguonKhachHangRow = ({ item, dbName, onReload, onDelete, onDataChanged }) => {
    const [ten, setTen] = useState(item.TenNguonKH);
    const handleSuaTen = () => {
        const trimmedTen = ten.trim();
        if (trimmedTen === "") {
            pushNotification("Tên nguồn khách hàng không được để trống.", "error");
            setTen(item.TenNguonKH);
            return;
        }
        if (trimmedTen === item.TenNguonKH) {
            return;
        }
        const data = { TenNguonKh: trimmedTen, IsActive: item.IsActive };
        NguonKhachHangApi.update(item.NguonKH_ID, data, dbName)
            .then(res => {
                if (res.status === 200) {
                    pushNotification("Cập nhật tên thành công!", "success");
                    onReload();
                    if (onDataChanged) onDataChanged();
                } else {
                    pushNotification(res.data?.Message || "Lỗi khi cập nhật.", "error");
                }
            })
            .catch(err => pushNotification("Lỗi: " + (err.message || "Không xác định"), "error"));
    };

    const handleNameKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSuaTen();
        }
    };

    const handleToggle = () => {
        const newStatus = item.IsActive === 0 ? 1 : 0;
        const data = { IsActive: newStatus };

        NguonKhachHangApi.changeStatus(item.NguonKH_ID, data, dbName)
            .then(res => {
                if (res.status === 200) {
                    pushNotification(!item.IsActive ? "Kích hoạt thành công!" : "Hủy kích hoạt thành công!", "success");
                    onReload();
                    if (onDataChanged) onDataChanged();
                } else {
                    pushNotification(res.data?.Message || "Lỗi khi đổi trạng thái.", "error");
                }
            })
            .catch(err => pushNotification("Lỗi: " + (err.message || "Không xác định"), "error"));
    };

    return (
        <div className="custom-table-row" style={{ minHeight: "56px", borderBottom: '1px solid #e0e0e0' }}>
            <div className="custom-table-cell flex-basis-50 flex-basis-50-sm">
                <span className="mobile-column-name color7-bold">Tên nguồn</span>
                <div className="center-wrapper word-break text-left" style={{ width: '100%', justifyContent: 'flex-start' }}>
                    <Form.Control
                        value={ten}
                        onChange={(e) => setTen(e.target.value)}
                        onKeyDown={handleNameKeyDown}
                        onBlur={handleSuaTen}
                    />
                </div>
            </div>
            <div className="custom-table-cell flex-basis-25 flex-basis-25-sm">
                <span className="mobile-column-name color7-bold">Active</span>
                <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                    <CustomCheckbox
                        id={`nguon-kh-${item.NguonKH_ID}`}
                        name={`nguon-kh-${item.NguonKH_ID}`}
                        checked={!!item.IsActive}
                        onChange={handleToggle}
                        label="Active"
                        className="d-inline-block"
                    />
                </div>
            </div>
            <div className="custom-table-cell flex-basis-25 flex-basis-25-sm">
                <span className="mobile-column-name color7-bold">Thao tác</span>
                <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                    <a type="button" className="popover-basic" onClick={() => onDelete(item)}>
                        <img src="/app-assets/images/icon-xoa-v2.png" title="Xóa" alt="Xóa" />
                    </a>
                </div>
            </div>

        </div>
    );
};